import { PersonaType, WorkPackageStats } from '@bechtel/types';
import { StatBlockGridData } from '@bechtel/client-dashboard-common';
import { bankersRound } from '@bechtel/client-common';
import { findIndex } from 'lodash';
import { t } from '@lingui/macro';

export function getStatBlockGridData(
  milestoneStats:
    | WorkPackageStats['plannedMilestones']
    | WorkPackageStats['earnedMilestones']
    | WorkPackageStats['approvedMilestones'],
  committedMilestoneStats?: WorkPackageStats['committedMilestones']
): StatBlockGridData[] {
  const statBlockGridData: StatBlockGridData[] = [
    {
      value: milestoneStats && milestoneStats.numMilestones.toString(),
      valueText: t`Milestones`,
      total: committedMilestoneStats && committedMilestoneStats.numMilestones.toString(),
    },
    {
      value: milestoneStats && milestoneStats.quantity && bankersRound(milestoneStats.quantity.quantity, 0).toString(),
      valueText: t`LF(Eq.)`,
      total:
        committedMilestoneStats &&
        committedMilestoneStats.quantity &&
        bankersRound(committedMilestoneStats.quantity.quantity, 0).toString(),
    },
    {
      value: milestoneStats && bankersRound(milestoneStats.hours, 0).toString(),
      valueText: t`Hours`,
      total: committedMilestoneStats && bankersRound(committedMilestoneStats.hours, 0).toString(),
    },
  ];
  return statBlockGridData;
}

export const WORKPACKAGE_PERSONA = [
  { id: PersonaType.SUPERINTENDENT, name: 'Superintendent' },
  { id: PersonaType.GENERAL_FOREMAN, name: 'General Foreman' },
  { id: PersonaType.FOREMAN, name: 'Foreman' },
  { id: PersonaType.FIELD_ENGINEER, name: 'Field Engineer' },
];

export function isWorkPackagePersona(persona: PersonaType) {
  return findIndex(WORKPACKAGE_PERSONA, (wpPersona) => wpPersona.id == persona) != -1;
}
